/* eslint-disable @typescript-eslint/no-explicit-any */
export interface TableColumn<T = any> {
    accessor?: keyof T & string | string;
    Cell?: (row: T, index: number) => JSX.Element;
    header: string;
    /** Tooltip text shown on a ⓘ icon next to the column header. */
    headerTooltip?: string;
    sortable?: boolean;
    textAlign?: 'left' | 'right' | 'center';
    width?: number | string;
    colspan?: number
}

export interface TableProps<T = any> {
    columns: TableColumn<T>[];
    data?: T[];
    showActions?: boolean;
    onRowClicked?: (item: T) => void;
    onSort?: (accessor: TableColumn<T>["accessor"], direction: SortDirection | null) => void;
    defaultSortState?: {
        accessor: TableColumn["accessor"];
        direction: SortDirection | null;
    };
    isLoading?: boolean;
}

export const SortDirection = {
  ASC: "asc",
  DESC: "desc",
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];